<template>
    <body>
    <form>
        <div class="imgcontainer">
            <img src="../assets/sappoQR.png"  style="background-color: white" alt="Avatar" class="avatar">
        </div>
        <div class="container" id="container">
            <label for="email"><b>E-mail</b></label>
            <input type="email" placeholder="name@server.domain" id="email"  v-model="this.business_email" required>
            <label for="fname"><b>Business Name</b></label>
            <input type="text" placeholder="Enter Name" id="fname" v-model="this.business_profile.name" required>
            <label for="lname"><b>Location/City</b></label>
            <input type="text" placeholder="Enter Location" id="lname" v-model="this.business_profile.location" required>
            <button v-if="!editBusiness" type="submit" :disabled="offNext" @click.prevent="goNext">Next ( <i class="fa fa-cc-stripe" aria-hidden="true"></i> payment / free trial )</button>
            <button v-else :disabled="offNext" @click.prevent="update_business">update</button>
            <button type="button" class="cancelbtn" @click.prevent="goBack">Cancel</button>
        </div>
    </form>
    <br>
    <div style="font-size: 10px;text-align: center">
        <span style="color: yellow"><i class="fa fa-shield" aria-hidden="true"></i> Privacy Policy</span> <br>
        The next data (E-mail) <span style="font-weight: bold">are not </span> stored on the App Server.
    </div>
    </body>
</template>
<script>
    import {generateHID} from "../hid.js"
    import {ulip_put} from "../https_requests.js"
    import {getBaseURL} from '../url_endpoints.js'
    export default {
        name:'NewBusiness',
        data() {
            return {
                business_profile : {
                    name:null,
                    location:null,
                    code:null,
                    id:null,
                    subscription_time:null,
                    subscription_months:0
                },
                business_email:null,
                editBusiness:false,
                baseURL:null,
            }
        },
        computed: {
          offNext() {
              if(this.business_email) {
                  let emailFormat = this.business_email.toLowerCase().match(
                      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
                  if(emailFormat) {
                      if(!this.business_profile.name || !this.business_profile.location) {
                          return true
                      }else {
                          return false
                      }
                  }else {
                      return true
                  }
              }else {
                  return true
              }
          }
        },
        mounted() {
            this.baseURL = getBaseURL()
            // check if edit profile
            const cbusiness = this.$store.getters.getCurrentBusiness
            //console.log('check current busines ...',cbusiness)
            if(!cbusiness) {
                //console.log('already new business')
            }else {
                this.business_profile.id = cbusiness.id
                this.business_profile.location = cbusiness.location
                this.business_profile.name = cbusiness.name
                // get email from localStorage
                const email = localStorage.getItem('business_email')
                this.business_email = !email ? '' : email
                this.editBusiness = true
            }
        },
        methods: {
            goBack() {
                if(this.editBusiness) {
                    // go back to the features
                    this.$router.push('/features')
                }else {
                    this.$router.push('/business_signin')
                }
            },
            update_business() {
               // update business profile
                const business_data = {
                    name:this.business_profile.name,
                    location: this.business_profile.location,
                }
               ulip_put(this.baseURL,'/business',this.business_profile.id,business_data).then(rsp => {
                   alert('Your Business '+rsp['name']+' data updated!')
                   // update email on local
                   localStorage.setItem('business_email',this.business_email)
                   // update on store data business
                   this.$store.commit('setCurrentBusinessName',business_data.name)
                   this.$store.commit('setCurrentBusinessLocation',business_data.location)
                   this.$router.push('/features')
               }).catch(err => {
                   alert(err.message + '\nBackend Server could be down! Try again later..')
               })
            },
            goNext() {
                // generate hash code for sign-in
                const hid_1step = generateHID(this.business_profile.name + this.business_profile.location + this.business_email)
                const d = new Date()
                const hid_2step = generateHID(hid_1step+d)
                this.business_profile.code = hid_2step
                // save /post on backend new business
                let b_candidate ={
                    name:this.business_profile.name,
                    location: this.business_profile.location,
                    code: this.business_profile.code,
                    subscription_time:d.getFullYear() + '-' + (d.getMonth()+1) + '-' + d.getDate(), // add to count 1 = january
                    subscription_months:'1'
                }
                // store in memory business candidate  till payment procedeed
                this.$store.commit('setBCandidate',b_candidate)
                //save local email
                localStorage.setItem('business_email',this.business_email)
                this.$router.push('/payment')
            }
        }
    }
</script>
<style lang="scss" scoped>
    body {
        font-family: Arial, Helvetica, sans-serif;
        text-align: left;
        background-color: black;
        color: white;
        height:100vh;
    }
    /*
    form {
        border: 3px solid #f1f1f1;
    }*/

    input[type=text], input[type=password], input[type=email] {
        width: 100%;
        padding: 10px 20px;
        margin: 5px 0;
        display: inline-block;
        border: 1px solid #ccc;
        box-sizing: border-box;

    }

    button {
        background-color: #4CAF50;
        color: white;
        padding: 10px 18px;
        margin: 8px 0;
        border: none;
        cursor: pointer;
        width: 100%;
        opacity: 0.7;
    }

    button:hover {
        opacity: 1.0;
    }
    button:disabled {
        background-color: darkgray;
    }

    .cancelbtn {
        width: 100%;
        padding: 10px 18px;
        background-color: #f44336;
        //float:right;
    }

    .imgcontainer {
        text-align: center;
        margin: 24px 0 12px 0;
    }

    img.avatar {
        width: 10%;
        border-radius: 30%;
    }

    .container {
        padding: 16px 30%;
    }

    span.psw {
        float: right;
        padding-top: 16px;
    }

    /* Change styles for span and cancel button on extra small screens */
    @media screen and (max-width: 414px) {
        span.psw {
            display: block;
            float: none;
        }
        .cancelbtn {
            width: 100%;
        }
        button {
            width: 100%;
        }
        .container {
            padding: 5px;
        }
    }
    a:visited {
        color: lightsalmon;
    }
</style>